import { Form, type FormInstance } from "antd";
import type { SourcingRequirementApplicationFormFields } from "../type";
import { UserFormFields } from "@/components/UserFormFields/UserFormFields";
import { SourcingRequirementFormFields } from "./SourcingRequirementFormFields";
import { AttachmentFileFormFields } from "./AttachmentFileFormFields";
import { FormulaChangeFields } from "./FormulaChangeFields";
import { MaterialStandardFields } from "./MaterialStandardFields";
import { useFormEditable } from "../hooks/useFormEditable";
import { useSourcingRequirementQuery } from "../hooks/useSourcingRequirementQuery";
import { useModal } from "@/hooks/modals/useModal";
import { useNowFlowNode } from "@/hooks/services/useFlow";

type Props = {
  form: FormInstance<SourcingRequirementApplicationFormFields>;
};
export const SourcingRequirementApplicationForm: React.FC<Props> = ({
  form,
}) => {
  const { props } = useModal("SOURCING_APPLICATION_20251202");
  const { viewStatus, mode } = props;
  const detail = useSourcingRequirementQuery(props.recordId);
  const nodeCode = useNowFlowNode(detail?.insId);

  const { isMainFormDisabled } = useFormEditable();

  const isProductionMaterial = detail?.sourcingType === "1";

  /**
   * 满足以下条件展示处方变更确认表单项：
   */
  const showFormulaChangeFieldsRules = [
    mode === "started" &&
      detail?.reviewStatus !== 3 &&
      detail?.formulaChange !== null,
    mode === "inReview" &&
      nodeCode === "RA_MANAGER" &&
      detail?.reviewStatus === 2,
    mode === "inReview" && detail?.formulaChange !== null,
  ];

  const showFormulaChangeFields = showFormulaChangeFieldsRules.some((r) => r);

  const canEditFormulaChangeFields =
    nodeCode === "RA_MANAGER" && mode === "inReview" && viewStatus === true;

  /**
   * 满足以下条件展示物料标准确认表单项：
   */
  const standardNodeCodes = [
    "QC_MANAGER",
    "e4433b6b-358f-4e27-99ec-3cdd7ab8976c",
  ];
  const isMatchStandardNode = Boolean(
    nodeCode && standardNodeCodes.includes(nodeCode),
  );
  const showMaterialStandardFieldsRules = [
    mode === "started" &&
      detail?.reviewStatus !== 3 &&
      detail?.standardChanged !== null,
    mode === "inReview" && isMatchStandardNode && detail?.reviewStatus === 2,
    mode === "inReview" && detail?.standardChanged !== null,
  ];

  const showMaterialStandardFields = showMaterialStandardFieldsRules.some(
    (r) => r,
  );

  const canEditMaterialStandardFields =
    isMatchStandardNode && mode === "inReview" && viewStatus === true;

  return (
    <Form
      layout="vertical"
      form={form}
      initialValues={{
        sourcingType: "1",
        materialList: [{}],
      }}
      disabled={isMainFormDisabled}
      onValuesChange={(changed, values) => console.log({ changed, values })}
    >
      {/* 申请人信息 */}
      <UserFormFields />

      {/* 寻源信息 */}
      <SourcingRequirementFormFields />

      {/* 相关附件 */}
      <AttachmentFileFormFields />

      {/* 处方变更确认 */}
      <FormulaChangeFields
        show={isProductionMaterial && showFormulaChangeFields}
        editable={canEditFormulaChangeFields}
      />

      {/* 物料标准确认 */}
      <MaterialStandardFields
        show={isProductionMaterial && showMaterialStandardFields}
        editable={canEditMaterialStandardFields}
      />
    </Form>
  );
};
